module.exports = __webpack_public_path__ + "static/media/twitterIcon.38635464.png";